@let fieldData = field();
@let formControl = control();

@if (formControl) {
  <div class="mb-6">
    <label class="flex gap-4 x-font-body-4">
      <input
        tuiCheckbox
        type="checkbox"
        [formControl]="formControl"
        size="m"
        class="ms-1"
      />
      <div>
        <span
          [class.font-extrabold]="fieldData.isHighlighted"
          class="x-text-wf-title"
        >
          {{ fieldData.title }}
        </span>
        @if (fieldData.validation?.isRequired) {
          <span class="font-extrabold">*</span>
        }
        @if (fieldData.helpText) {
          <tui-icon
            [tuiTooltip]="fieldData.helpText"
            (click)="$event.stopPropagation(); $event.preventDefault()"
          ></tui-icon>
        }
      </div>
    </label>
    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <div class="x-text-wf-error x-font-body-5 mt-1 absolute">
        @if (
          formControl.hasError('required') ||
          formControl.hasError('requiredTrue')
        ) {
          <span>Обязательное поле</span>
        }
        @if (formControl.hasError('customError')) {
          <span>Ошибка валидации</span>
        }
      </div>
    }
  </div>
}
